import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { LayoutService, ColorScheme } from '../layout/service/app.layout.service'; // Ajusta la ruta según sea necesario

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2, private layoutService: LayoutService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public applyStoredTheme(): void {
    const storedStyle = localStorage.getItem('userStyle');
    if (storedStyle) {

      this.layoutService.updateConfig({
        colorScheme: storedStyle as ColorScheme
      });
      this.applyTheme(storedStyle as ColorScheme);
    }
  }

  public applyTheme(colorScheme: ColorScheme): void {
    const themeLink: HTMLLinkElement = this.renderer.selectRootElement('#theme-link', true);
    const newHref = themeLink.href.replace(/theme-\w+/, `theme-${colorScheme}`);
    this.renderer.setAttribute(themeLink, 'href', newHref);

    themeLink.onload = () => {

    };
  }

  public reloadTheme(): void {
    this.applyStoredTheme();
  }
}
